'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = subscribe;

var _createStateStream = require('./createStateStream');

var _createStateStream2 = _interopRequireDefault(_createStateStream);

var _render = require('./render');

var _render2 = _interopRequireDefault(_render);

var _most = require('most');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function subscribe(store, heats) {
  var state$ = (0, _createStateStream2.default)(store);

  var streams = heats.map(function (heat) {
    var effect$ = state$.map(heat);
    var action$ = (0, _render2.default)(effect$);
    return action$;
  });

  var action$ = (0, _most.mergeArray)(streams);

  var subscription = action$.subscribe({
    next: function next(action) {
      return store.dispatch(action);
    },
    error: function error(_error) {
      return console.log('error', _error);
    },
    complete: function complete() {
      return console.log('completed');
    }
  });

  return function () {
    return subscription.unsubscribe();
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-heat/lib/index.js
// module id = 307
// module chunks = 0